export interface AgreementsDto {
	id: string;
	text: string;
	title: string;
	status: CustomerAgreementStateType;
	codeName: string;
}

export interface AgreementRequestDto {
	agreementId: string;
	agreementState: CustomerAgreementStateType;
}

export enum CustomerAgreementStateType {
	Active = 1,
	Inactive = 2,
	Unseen = 3
}
